/**
 * api接口文档
 * 例: "login": "POST,/user/login",
 */
export default {
  // Common
  'getweixinsign': 'POST,/Weixin/getsign',
  'appOperation': 'GET,/index/appOperation', // (APP)获取运营位广告
  'createOrgList': 'GET,/course/createOrgList', // 获取供课院校(供课数量前10)
  'courseCategories': 'GET,/common/courseCategories', // 获取课程分类

  'searchHotKeyWord': 'GET,/search/hotKeyword', // 热门关键字
  'searchCourse': 'GET,/search/list', // 搜索

  // course
	'mycourse': 'GET,/home/course/list', // 我的课程
  'courseList': 'GET,/course/listData', // 获取课程列表
  'getCourseInfo': 'GET,/course/getCourseInfo', // 获取课程详情页课程信息
  'getCycleInfo': 'GET,/course/getCycleInfo', //获取课程周期信息
  'joinCourse': 'POST,/home/course/joinLearn', // 加入课程

  // acount
  'user': 'GET,/home/member/user',
  'login': 'POST,/user/login', // 用户登陆
	'logout': 'POST,/user/logout', // 退出登陆
	'sendCode': 'POST,/user/sendCode', // 发送验证码
	'resetPwd' : 'POST,/user/resetPwd', // 设置新的密码
	'register': 'POST,/user/register', // 注册
	'loginByCode': 'POST,/user/loginByCode', // 注册
	'resetPwd': 'POST,/user/resetPwd', // 重置密码

	// 微专业
	'profession': 'GET,/home/profession/index', // 我的微专业
	'getProfessionList': 'GET,/profession/getProfessionList', // 微专业列表
	'listProfession': 'GET,/profession/listProfession', // 移动端微专业列表
  'professionInfo': 'GET,/profession/getInfo', // 微信微专业详细接口
  'getCollegeCourseList':'GET,/profession/collegeCourseList',//根据学院获取微专业列表


	// 支付
	'orderForGoods': 'POST,/order/orderForGoods', // 生成订单接口
	'updateOrder': 'POST,/order/updateOrder', // 修改支付订单
	'checkPay': 'POST,/order/checkPay', // 检查订单是否支付成功
	'getOrderInfo': 'GET,/order/getOrderInfo',
	'orderCouponList': 'GET,/order/couponList', // 订单能使用的优惠券列表
	'orderCouponWay' : 'GET,/order/couponWay', // 选择优惠方式

	// 优惠券
	'couponList' : 'GET,/home/coupon/list', // 我的优惠券列表
	'couponInfo': 'GET,/index/coupon', // 校园大使详情
	'couponReceive' : 'POST,/home/coupon/receive', // 领取优惠券
	'receiveCouponByPhone': 'POST,/index/receiveCouponByPhone', // 手机号领取优惠券

	// Bee
	'getBee': 'GET,/home/bee/getBee', // 获取校园大使信息
	'friendOrder': 'GET,/home/bee/friendOrder', // 分页获取校园大使好友购买记录
	'beeApply': 'POST,/home/bee/apply', // 申请成为校园大使
	'beeWithdrawCash': 'POST,/home/bee/withdrawCash', // 校园大使提现
	'beeWithdrawCashList': 'POST,/home/bee/withdrawCashList', // 校园大使提现记录列表
	'beeProfessionList': 'POST,/home/bee/professionList', // 校园大使可分享的微专业
	'beeCourseList': 'GET,/home/bee/courseList', // 校园大使可分享的课程
	'beeShareCnt': 'POST,/home/bee/shareCnt'

};



// WEBPACK FOOTER //
// ./src/store/apiurl.js